let charts = {
  BarChart: require("./chart/BarChart"),
  LineChart: require("./chart/LineChart"),
  PieChart: require("./chart/PieChart"),
  Legend: require("./chart/Legend")
};

module.exports = charts;